import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.75 3.75H15a1.5 1.5 0 0 0-1.5 1.5v8.25a1.5 1.5 0 1 1-3 0V5.25A1.5 1.5 0 0 0 9 3.75H5.25a1.5 1.5 0 0 0-1.5 1.5v8.25A8.25 8.25 0 0 0 12 21.75h.063c4.514-.034 8.187-3.777 8.187-8.344V5.25a1.5 1.5 0 0 0-1.5-1.5m0 1.5v3H15v-3zM9 5.25v3H5.25v-3zm3.052 15A6.75 6.75 0 0 1 5.25 13.5V9.75H9v3.75a3 3 0 0 0 6 0V9.75h3.75v3.656c0 3.75-3 6.817-6.698 6.844"
    }, null, -1)
  ])))
}
export default { render: render }